import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { useCursorPagination } from '@/hooks/useCursorPagination';
import { fetchMarketSuppliersPage, marketSuppliersTableQueryKey } from '../config/queryKey';
interface UseMarketSuppliersDataParams {
  chainId: ChainId;
  marketId: string;
  first: number;
}

/** Cursor-paginated data hook for the market suppliers table, over `market.suppliers`. */
const useMarketSuppliersData = t0 => {
  const $ = _c(10);
  const {
    chainId,
    marketId,
    first
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== chainId || $[1] !== first || $[2] !== marketId) {
    const filters = {
      chainId,
      marketId,
      limit: first
    };
    t2 = useCursorPagination;
    t1 = marketSuppliersTableQueryKey(filters);
    t3 = cursor => fetchMarketSuppliersPage(filters, cursor);
    $[0] = chainId;
    $[1] = first;
    $[2] = marketId;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = `${chainId}:${marketId}:${first}`;
  let t5;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t3,
      resetKey: t4,
      trustCursorOnEmptyPage: true
    };
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t2(t5);
};
export default useMarketSuppliersData;